import { makeStyles } from '@material-ui/core';
import React from 'react'
import FormSae from './Components/Formulario/formSae';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f5f5f5",
    marginTop: "80px",
    marginBottom: "60px",
  },
}));
 
function App() {

  const classes = useStyles();

  return (
    <div className={classes.root}>
        <FormSae />
    </div>
  );
}

export default App;
